import { useId } from 'react';

import { ModalFrame } from 'components/ui/modal-frame';

interface Props {
  onClose: () => void;
  description: string;
}

/** Aviso de ação concorrente da fila ("Ops!"): só o texto e o fechar. */
export default function ModalAlert({ onClose, description }: Props) {
  const textoId = useId();

  return (
    <ModalFrame
      isOpen
      appearance="cartao"
      size="sm"
      title="Ops!"
      descriptionId={textoId}
      onClose={onClose}
      closeLabel="Fechar modal"
    >
      {/* D3: 12,5px e 30px não têm degrau no Tailwind. */}
      <p id={textoId} className="m-0 px-5 pb-[26px] pt-2 text-[12.5px] leading-[1.65] text-content lg:px-[30px]">
        {description}
      </p>
    </ModalFrame>
  );
}
